// We list the icons we use explicitly because this reduces our bundle size.

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  faArrowCircleLeft,
  faArrowCircleRight,
  faAngleRight,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faArrowLeft,
  faArrowRight,
  faBalanceScaleLeft,
  faBan,
  faBars,
  faBell,
  faBicycle,
  faBookOpen,
  faBriefcase,
  faBullhorn,
  faCalculator,
  faCamera,
  faCar,
  faCaretUp,
  faCaretDown,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronCircleDown,
  faChevronCircleUp,
  faCircle,
  faCirclePlus,
  faClipboard,
  faClock,
  faCloud,
  faCoffee,
  faCog,
  faComment,
  faComments,
  faCalendarAlt,
  faCrown,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFrown,
  faGavel,
  faGift,
  faGlobeEurope,
  faHandHoldingHeart,
  faHandsHelping,
  faHandshake,
  faHashtag,
  faHeart,
  faHome,
  faInfoCircle,
  faLeaf,
  faLink,
  faLock,
  faLockOpen,
  faMap,
  faMapMarkerAlt,
  faMeh,
  faMinus,
  faMinusCircle,
  faPen,
  faPlus,
  faQuestionCircle,
  faReply,
  faSave,
  faSearch,
  faShareAlt,
  faShoppingCart,
  faSignOutAlt,
  faSlash,
  faSliders,
  faSmile,
  faSpinner,
  faSync,
  faTimes,
  faThumbsDown,
  faThumbsUp,
  faTimesCircle,
  faTrashAlt,
  faTrophy,
  faUser,
  faUsers,
  faWalking,
} from '@fortawesome/free-solid-svg-icons'

import {
  faFacebook,
  faTwitter,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faAddressBook,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faArrowCircleRight,
  faArrowCircleLeft,
  faArrowCircleRight,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faBan,
  faBalanceScaleLeft,
  faBars,
  faBell,
  faBicycle,
  faBookOpen,
  faBriefcase,
  faBullhorn,
  faCalculator,
  faCamera,
  faCar,
  faCaretUp,
  faCaretDown,
  faChartBar,
  faCheckCircle,
  faCheck,
  faChevronCircleDown,
  faChevronCircleUp,
  faCircle,
  faCirclePlus,
  faClipboard,
  faClock,
  faCloud,
  faCog,
  faCoffee,
  faComment,
  faComments,
  faCalendarAlt,
  faCrown,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFrown,
  faGavel,
  faGift,
  faGlobeEurope,
  faHandHoldingHeart,
  faHandsHelping,
  faHandshake,
  faHashtag,
  faHeart,
  faHome,
  faInfoCircle,
  faLeaf,
  faLink,
  faLock,
  faLockOpen,
  faMap,
  faMapMarkerAlt,
  faMeh,
  faMinus,
  faMinusCircle,
  faPen,
  faPlus,
  faQuestionCircle,
  faReply,
  faSave,
  faSearch,
  faShareAlt,
  faShoppingCart,
  faSignOutAlt,
  faSlash,
  faSliders,
  faSmile,
  faSpinner,
  faSync,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTrophy,
  faUser,
  faUsers,
  faWalking,
  faFacebook,
  faTwitter,
  faWhatsapp
)

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VIcon', FontAwesomeIcon)
})
